import { ArrowBackIcon } from '@chakra-ui/icons';
import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';
import { MdLocationOn } from 'react-icons/md';
import useCartStore from '../../../store/cartStore';
import { useNavigate } from 'react-router-dom';
import { CartContext } from '../../../context/cart';

export const Navbar = () => {
  const { location, setIsLocationOpen } = useCartStore();
  const { activeStep, setActiveStep, cartPlans } = React.useContext(CartContext);
  const navigate = useNavigate();

  // If cart is empty, we might want to hide the navbar or parts of it
  if (!cartPlans || cartPlans.length === 0) {
    return null; // Entirely hide the Navbar when cart is empty for a cleaner checkout flow
  }

  return (
    <Flex
      bg={'teal'}
      color={'white'}
      py={5}
      px={['5', '12', '12', '24']}
      justifyContent={'space-between'}
      width={'100%'}
    >
      {activeStep > 1 ? (
        <Flex
          gap={3}
          alignItems={'center'}
          sx={{
            cursor: 'pointer',
            fontSize: 'xl',
          }}
          onClick={() => {
            if (activeStep > 1) {
              setActiveStep(activeStep - 1);
            } else {
              navigate('/');
            }
          }}
        >
          <ArrowBackIcon />
          <Text>Back</Text>
        </Flex>
      ) : (
        <Box width="100px" /> // Placeholder to maintain spacing if needed, or just null
      )}
      <Flex
        alignItems={'center'}
        gap={2}
        cursor={'pointer'}
        onClick={() => setIsLocationOpen(true)}
      >
        <MdLocationOn size={28} />
        <Box>
          <Text fontSize={20} fontWeight={600}>
            {!location && 'Click Here'}
            {location && `${location.split(' ')[0]} ${location.split(' ')[1] || ''}`}
          </Text>
          <Text fontSize={14}>
            {!location && 'Fetch Location'}
            {location && location.split(' ').map((loc, index) => {
              if (index === 0 || index === 1) return null;
              return <span key={index}>{loc} </span>;
            })}
          </Text>
        </Box>
      </Flex>
    </Flex>
  );
};
